const LOG_PREFIX = "[OCM][PageSense] "
let pageSense = async (utils) => {
  return new Promise((resolve, reject) => {
    let pageType = 'ROS';
    let subPaths = window.location.pathname.replace("/", "").split("/") || [];
    let customPaths = ["teleftaia-nea", "diafimisi", "privacy", "epikinonia"];
    // Keep only String values in subPaths (removes null and empty)
    subPaths = subPaths.filter(String);
    // The actual page sense goes here
    if (subPaths.length === 0) {
      pageType = "Home";
    } else if (subPaths.length === 1) {
      if (customPaths.indexOf(subPaths[0]) >= 0) {
        pageType = "Custom-1";
      } else {
        pageType = "Category";
      }
    } else if (subPaths.length >= 2) {
      if (subPaths[0] === "blogview" || subPaths[1] === "page") {
        pageType = "Category";
      } else {
        pageType = "Article";
      }
    }
    
    window.googletag = window.googletag || {cmd: []}

    utils.contentLoaded().then(() => {

      // GAM targeting
      window.googletag.cmd.push(() => {
        googletag.pubads().setTargeting('page', [pageType])
        //         if (pageType === 'Category') {
        //           sub_paths.shift()
        //           googletag.pubads().setTargeting('category', sub_paths)
        //         }
      })

      // Slot definitions
      defineSlots(utils, pageType)

      // Ad div detection and display
      let ad_placements = document.querySelectorAll('div[data-ocm-ad]')
      ad_placements.forEach((ap) => {
        window.googletag.cmd.push(() => { googletag.display(ap.id) })
      })
    })
    resolve(pageType)
  });
};

let defineSlots = (utils, pageType) => {

  window.googletag.cmd.push(() => {

    var sidebar_desk = googletag.sizeMapping()
    .addSize([0, 0], [])
    .addSize([340,0], [])
    .addSize([768, 0], [[300,250],[300,600]])
    .addSize([1024, 0],[[300,250],[300,600]])
    .build();

    var mobile_sticky = googletag.sizeMapping()
    .addSize([0, 0], [[320,100],[320,50]])
    .addSize([340,0], [[320,100],[320,50]])
    .addSize([768, 0], [])
    .addSize([1024, 0],[])
    .build();


    if (pageType==="Article") {
      if (!utils.is_mobile) {
        googletag.defineSlot('/75351959,31156878/cyclades24.gr/sidebar1',[[300,600],[300,250]],'sidebar1').defineSizeMapping(sidebar_desk).addService(googletag.pubads());
        googletag.defineSlot('/75351959,31156878/cyclades24.gr/sidebar2',[[300,600],[300,250]],'sidebar2').defineSizeMapping(sidebar_desk).addService(googletag.pubads());
        googletag.defineSlot('/75351959,31156878/cyclades24.gr/sidebar3',[[300,600],[300,250]],'sidebar3').defineSizeMapping(sidebar_desk).addService(googletag.pubads());
        googletag.defineSlot('/75351959,31156878/cyclades24.gr/sidebar4',[[300,600],[300,250]],'sidebar4').defineSizeMapping(sidebar_desk).addService(googletag.pubads());
      }
    }

  })
}
module.exports = pageSense;